import { languageItems } from '../../../../i18n'
import { isStringNotEmpty } from '../../../NonReact/utils/GlobalFunctions'

export const LOCALE_EN_US = 'en_US'
export const LOCALE_EN_GB = 'en_GB'
export const LOCALE_EN_UK = 'en_GB'
export const LOCALE_DE_DE = 'de_DE'
export const LOCALE_ES_MX = 'es_MX'
export const LOCALE_IT_IT = 'it_IT'
export const LOCALE_EN_CA = 'en_CA'
export const LOCALE_FR_CA = 'fr_CA'

/**
 * The set of locales for which the FE actually ships i18n bundles, derived
 * from `src/i18n/index.ts` (auto-generated by `AssembleLanguageIndexNode.js`
 * from the directories under `src/i18n/`). Any locale outside this set must be
 * coerced to the default locale before being handed to
 * {@link CLanguageHandler.loadBundle}, which would otherwise throw
 * `Invalid language bundle`.
 */
export const SUPPORTED_I18N_LOCALES: ReadonlySet<string> = new Set<string>([
    LOCALE_EN_GB,
    LOCALE_EN_US,
    ...Object.keys(Object.values(languageItems)[0]?.i18nBundles ?? {})
])

/**
 * Resolve a locale to one with i18n bundles available, falling back to
 * `en_GB` when the supplied value is empty or unsupported.
 *
 * This guards code paths (login, header, session restore) that pass a locale
 * through to {@link CLanguageHandler} where an unknown locale would otherwise
 * throw `Invalid language bundle` when a bundle is loaded.
 *
 * @param locale - Locale identifier to validate, typically sourced from the
 *     backend session or persisted user preference.
 * @returns The supplied locale when it has i18n bundles, otherwise
 *     {@link LOCALE_EN_GB}.
 */
export const resolveSupportedLocale = (locale: Nullable<string>): string => {
    if (isStringNotEmpty(locale) && SUPPORTED_I18N_LOCALES.has(locale)) return locale

    return LOCALE_EN_GB
}
